module.exports = __webpack_public_path__ + "img/success-dark.264f10ee.svg";